import { createFileRoute } from '@tanstack/react-router';

import { GradesPage } from '@/features/student/GradesPage';
import { requireRole } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/grades')({
  beforeLoad: () => requireRole('student'),
  component: GradesPage,
});
